import $ from "jquery";
import moment from "moment/moment";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import init from '../AccessControl/Check';
import { CSVLink } from "react-csv";
import number_format from "../../../components/Constants/NumberFormat";

import DatePickerV2 from "./../../../components/Date/DatePicker-v2";
import DatePickerRange from "./../../../components/Date/DatePickerRange";


const AllOrders = () => {

    const pageName = "Order View";
    const isAccess = init(pageName);
    var setDatePicker = () => {
        $("#date-div").hide();
        $("#date-range-div").hide();

        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);


        var v = $("#date-range-data").val();
        if (v === "custom") {
            $("#date-range-div").show();
        }
        else if (v === "all") {
            $("#date-div").attr("style", "display:flex");
        }
    }

    const [orderList, setOrderList] = useState([]);
    const [summary, setSummary] = useState({});
    const [isFilter, setIsFilter] = useState(false);
    const [reqParam, setReqParam] = useState({
        page: 1
    })


    const filterClick = () => {

        $("#filter-toggle-icon").toggleClass("rotate-180");
        $(".custom-btn.filter").toggleClass("active");

        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const [apiData, setApiData] = useState({});

    useEffect(() => {
        // Get All Orders List
        PostLoginGetApi("order/logs", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setOrderList(responseData["data"]["list"]);
                    setSummary(responseData["data"]["summary"]);

                    setExcelData([]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })

    }, [isFilter, reqParam]);


    const [excelData, setExcelData] = useState([]);
    const excelPrepare = () => {
        let i = 0;
        let arr = [];
        arr[i++] = ['', 'SHOP HISTORY REPORT'];
        arr[i++] = ['', 'DOWNLOAD AT', moment().format('DD MMM, YYYY hh:mm A')];
        arr[i++] = [];
        arr[i++] = ['', 'FILTER BY'];
        arr[i++] = ['', 'DATES', 'FROM', reqParam.from ?? "", 'TO', reqParam.end ?? ""];
        arr[i++] = ['', 'STATUS', reqParam.search ?? "ALL"];
        arr[i++] = ['', 'DELIVERY TYPES', reqParam.delivery_types ?? "ALL"];
        arr[i++] = ['', 'SEARCH BY PHONE', reqParam.phone ?? "N/A"];
        arr[i++] = ['', 'SEARCH BY TRANSACTION ID', reqParam.code ?? "N/A"];


        arr[i++] = [];
        arr[i++] = ['SNO', 'DATE TIME', 'TRANSACTION ID', 'CUSTOMER NAME', 'CUSTOMER PHONE', 'TOTAL QTY', 'ITEM QTY', 'ITEM NAME', 'DELIVERY TYPE', 'PAYMENT STATUS', 'ORDER STATUS', 'SETTLEMENT STATUS', 'REGULAR PRICE (?)', 'DISCOUNT (?)', 'AMOUNT (?)', 'SETTLEMENT CHARGE (?)', 'NET AMOUNT (?)'];

        // Get All Orders List
        PostLoginGetApi("order/logs-all", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);


                if (responseData["code"] === 200) {
                    let sum = { 'qty': 0, 'payable': 0, 'commission': 0, 'net': 0 };
                    let data = responseData["data"]["list"] ?? [];

                    data.forEach((val, index) => {

                        // Set CSV Data Arr
                        arr[i++] = [index + 1, moment(val.created_at).format("DD MMM, YYYY hh:mm A"), val.order_unique_id, val.customer_info?.customer_name ?? "N/A",
                        val.customer_info?.customer_mobile?.toString() ?? "N/A", val.items ?? 0, '-', '', val.delivery_type ?? 'N/A', val.payment_status,
                        (val.payment_status !== "Unpaid") ? val.status : "N/A",
                        ((val.payment_status !== "Unpaid" || val.payment_status !== "Refunded") && val.status !== 'Cancelled') ? val.settlement : "N/A",
                        val.amount ?? 0, val.discount_amount ?? 0, val.payable_amount ?? 0, (val.payment_status !== "Unpaid") ? (val.commission_amount ?? 0) : "N/A",
                        ((val.payment_status !== "Unpaid" || val.payment_status !== "Refunded") && val.status !== 'Cancelled') ? (val.net_amount ?? 0) : "N/A"
                        ];

                        let itemArr = val.item_details ?? [];
                        itemArr.forEach((itemVal) => {
                            arr[i++] = ['', '-', '-', '-', '-', '-', itemVal?.quantity, itemVal?.name, '-', '-', '-', '-',
                                itemVal?.unit_price, itemVal?.discount_amount, itemVal?.total_price, '-', '-'];
                        });

                        sum.qty += val.items ?? 0;
                        sum.payable += val.payable_amount ?? 0;
                        if (val.payment_status !== "Unpaid") {
                            sum.commission += val.commission_amount ?? 0;
                            sum.net += val.net_amount ?? 0;
                        }
                    });


                    arr[i] = ['', 'TOTAL', '', '', '', sum.qty, '', '', '', '', '', '', number_format(sum.payable, 2), number_format(sum.commission, 2), number_format(sum.net, 2)];

                    setExcelData(arr);
                }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            return true;
        });
    }

    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }

    const filter = () => {

        reqParam.search = $("#all-status").val() ?? "";
        reqParam.delivery_types = $("#delivery-types").val() ?? "";
        reqParam.settlement_types = $("#settlement-types").val() ?? "";
        reqParam.payment_types = $("#payment-types").val() ?? "";

        reqParam.page = 1;
        reqParam.phone = $("#search-by-phone").val() ?? "";
        reqParam.code = $("#search-by-transaction-id").val() ?? "";

        // Date Filter
        let from = "", end = "";
        if ($("#date-range-data").val() === "custom") {
            from = $("#fromDate").val();
            end = $("#toDate").val();

            if (from.length === 0 || end.length === 0) {
                from = "";
                end = "";
            }
            else {
                let nextDate = new Date(end);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");
                end = nextDate;
            }
        }
        else if ($("#date-range-data").val() === "all") {
            const singleDatePicker = $("#singleDatePicker").val();
            if (singleDatePicker.length !== 0) {
                let nextDate = new Date(singleDatePicker);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");

                from = singleDatePicker;
                end = nextDate;
            }
        }


        reqParam.from = from;
        reqParam.end = end;

        setReqParam({ ...reqParam });
        setIsFilter(true);
    }

    const resetFilterData = () => {

        $("#date-range-data").val("custom");
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
        $("#to-date-picker").val("");


        $("#all-status, #delivery-types, #settlement-types").val('all');
        $("#payment-types").val("");
        $("#search-by").val("search-by-phone");
        $("#search-by-phone, #search-by-transaction-id").val("");

        $("#search-by-transaction-id").hide();
        $("#search-by-phone").show();

        $("#date-div").hide();
        $("#date-range-div").show();


        filter();
        setIsFilter(false);
    }

    const setSearchParam = () => {

        $("#search-by-phone").val("");
        $("#search-by-transaction-id").val("");


        const search_by = $("#search-by").val();
        $("#search-by-phone").hide();
        $("#search-by-transaction-id").hide();

        $("#" + search_by).show();
        $("#" + search_by).focus();
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="custom-container w-full font-montserrat flex">

            {/** Left Side */}
            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-2 pt-0">
                    <div className="w-1/2 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-1 pt-6 mb-5">Here’s your shop history at a glance</h6>
                    </div>

                    <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">

                        {(excelData.length === 0) ?
                            <button onClick={excelPrepare} className="custom-btn mr-2 text-center">Prepare CSV</button>
                            :
                            <CSVLink className="custom-btn mr-2 text-center" filename={"shop-history-report.csv"} onClick={() => { return true; }} data={excelData}>
                                Export CSV
                            </CSVLink>
                        }


                        <Link to="#" onClick={filterClick} className="custom-btn filter text-center w-[92px]">Filter</Link>
                        <svg id="filter-toggle-icon" className='static -ml-4' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="#1A202C" />
                            <path d="M17 19L13 15L17 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
                        </svg>
                    </div>
                </div>

                {/* <div className="w-full flex overflow-hidden text-left py-4 pt-2">
                    <div className="box hover-black-green w-1/6 py-5 h-auto bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Pending
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.processing ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/6 py-5 h-auto ml-[1%]  bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Accepted
                        </Link>

                        <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary?.accepted ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/6 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Cancelled
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.cancelled ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/6 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Completed
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.completed ?? 0}</h3>
                    </div>
                </div> */}

                <div className="w-full flex overflow-hidden text-left py-4 pt-2">
                    <div className="box hover-black-green w-1/6 py-5 h-auto bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Paid
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.total_paid ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/6 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Accepted
                        </Link>

                        <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary?.accepted ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/6 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Shipped
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.shipped ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/6 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Delivered
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.delivered ?? 0}</h3>
                    </div>
                    <div className="box hover-black-green w-1/6 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Refunded
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.refunded ?? 0}</h3>
                    </div>
                    <div className="box hover-black-green w-1/6 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Cancelled / Rejected
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">
                            {summary?.cancelled ?? 0}
                            <span className="mx-1 font-light text-gray-500">/</span>
                            {summary?.rejected ?? 0}
                        </h3>
                    </div>
                </div>


                {/* DATA TABLE */}
                <div className="flex flex-col w-full pt-2">
                    <div className='-m-1.5 overflow-x-auto pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className="border rounded-lg shadow overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="px-4 py-3 text-center">#</th>
                                            <th scope="col" className="px-6 py-3">Transaction</th>
                                            <th scope="col" className="px-6 py-3">Customer</th>
                                            <th scope="col" className="px-2 py-3 text-center">Items</th>
                                            <th scope="col" className="px-2 py-3 text-center">Type</th>
                                            <th scope="col" className="px-2 py-3 text-center">Payment Status</th>
                                            <th scope="col" className="px-2 py-3 text-center">Order Status</th>
                                            <th scope="col" className="px-2 py-3 text-center">Settlement</th>
                                            <th scope="col" className="px-2 py-3 text-center" title="Regular Price">MRP</th>
                                            <th scope="col" className="px-2 py-3 text-center" title="Discount">Discount</th>
                                            {/*<th scope="col" className="px-2 py-3 text-center" title="Coupon Amount">Coupon</th>*/}
                                            <th scope="col" className="px-2 py-3 text-center">Amount</th>
                                            {/* <th scope="col" className="px-2 py-3 text-center">Charge</th>
                                            <th scope="col" className="px-2 py-3 text-center">Payable</th> */}
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200'>
                                        {(orderList.length === 0) &&
                                            <tr key="0">
                                                <td className='px-6 py-1 text-center' colSpan={12}>
                                                    <p className='py-4'>No orders available</p>
                                                </td>
                                            </tr>
                                        }

                                        {orderList.map((data, index) => (
                                            (data !== null) &&
                                            <tr key={index}>
                                                <td className='py-4 text-center border-r-2 font-semibold'>{data.sno ?? ++index}</td>
                                                <td className='px-6 py-4 border-r-2'>
                                                    <Link to={`/dashboard/orders/order-invoice/${data.id}`} className='cursor-pointer text-blue-500 font-semibold'>{data.order_unique_id}</Link>
                                                    <br />{moment(data.created_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='px-6 py-4 border-r-2'>
                                                    {(data.customer_info?.customer_name.length === 0) ?
                                                        <>N/A</>
                                                        :
                                                        <>{data.customer_info?.customer_name}</>
                                                    }
                                                    <br />
                                                    {data.customer_info?.customer_mobile}
                                                </td>
                                                <td className='px-2 py-4 border-r-2 text-center'>{data.items ?? 0}</td>
                                                <td className='px-2 py-4 border-r-2 text-center'>{data.delivery_type}</td>

                                                <td className='px-2 py-4 border-r-2 text-center'>
                                                    {(data.payment_status === "Unpaid" || data.payment_status === "Refunded") ?
                                                        <span className="bg-red-500 px-1.5 py-1 text-sm text-white font-semibold rounded-md">{data.payment_status}</span>
                                                        :
                                                        <span className="bg-green-500  px-1.5 py-1 text-sm text-white font-semibold rounded-md">{data.payment_status}</span>
                                                    }
                                                </td>

                                                <td className='px-2 py-4 border-r-2 text-center'>
                                                    {(data.status === "Cancelled" || data.status === 'Refunded' || data.status === 'Rejected') ?
                                                        <span className="bg-red-500 px-1.5 py-1 text-sm text-white font-semibold rounded-md">{data.status}</span>
                                                        :
                                                        <span className="bg-green-500 px-1.5 py-1 text-sm text-white font-semibold rounded-md">{data.status}</span>
                                                    }
                                                </td>

                                                <td className='px-2 py-4 border-r-2 text-center font-semibold'>
                                                    {((data.payment_status === 'Unpaid' || data.payment_status === "Refunded") || data.status === "Cancelled" || data.status === 'Refunded')
                                                        ? "-" :
                                                        <>{data.settlement}</>
                                                    }
                                                </td>
                                                <td className='px-2 py-4 border-r-2 text-center'>{data.amount}</td>
                                                <td className='px-2 py-4 border-r-2 text-center'>{data.discount_amount}</td>
                                                {/*<td className='px-2 py-4 border-r-2 text-center'>
                                                    {data.coupon_amount}
                                                    {(data.coupon_code) && <><br/>({data.coupon_code})</>}
                                                </td>*/}
                                                <td className='px-2 py-4 text-center'>{data.payable_amount}</td>
                                                {/* <td className='px-2 py-4 border-r-2 text-center'>
                                                    { ((data.payment_status === 'Unpaid' || data.payment_status === 'Refunded' ) && data.status === "Cancelled") ? "-" : 
                                                        <>{data.commission_amount}</>
                                                    }
                                                </td>
                                                <td className='px-2 py-4 text-center'>
                                                {((data.payment_status === 'Unpaid' || data.payment_status === 'Refunded' ) && data.status === "Cancelled") ? "-" : 
                                                    <>{process.env.REACT_APP_CURRENCY_SYMBOL} {data.net_amount}</>
                                                }
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>
                            {/* Pagination */}
                            {(apiData?.meta?.from) !== undefined &&
                                <>
                                    <p className='float-left mt-7'>
                                        {`Showing ${apiData?.meta?.from * 1} - ${apiData?.meta?.to * 1} out of ${apiData?.meta?.total * 1}`}
                                    </p>


                                    {(apiData?.links?.next !== null && apiData?.links?.next !== "") &&
                                        <button onClick={() => pagination(1)} className="custom-btn float-right mt-5 ml-2">
                                            Next Page&nbsp;&nbsp;&rarr;
                                        </button>
                                    }

                                    {(apiData?.links?.prev !== null && apiData?.links?.prev !== "") &&
                                        <button onClick={() => pagination(0)} className="custom-btn float-right mt-5">
                                            &larr;&nbsp;&nbsp;Previous Page
                                        </button>
                                    }
                                </>
                            }

                        </div>
                    </div>
                </div>


            </div>

            {/* Right Side */}
            <div id="filter-div" className="custom-container-right float-right w-1/5 pl-2 pb-10 pt-4 pr-1 justify-center custom-scroll-auto mb-20 no-need-without-shadow">
                <div className="relative">
                    <h6 className="text-lg px-3 font-base pb-2 pl-2" style={{ boxShadow: "0 3px 0 0 rgb(0 0 0 / 1%)" }}>Filter Orders</h6>

                    <div className="box-full w-full  text-justify py-2 pl-2">
                        <div className="w-full float-left pt-2">
                            <select onChange={setDatePicker} id="date-range-data" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="custom">
                                <option value="all">Single Date</option>
                                <option value="custom">Date Range</option>
                            </select>
                            <DatePickerV2 />
                            <DatePickerRange />
                        </div>
                    </div>

                    <div className="box-full block w-full h-full text-justify pl-2">
                        <div className="w-full float-left pb-1 pt-6">
                            <select id="all-status" className='w-full mt-0 mb-2 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">Order Statuses</option>
                                <option value="pending">Pending</option>
                                <option value="accepted">Accepted</option>
                                <option value="completed">Completed</option>
                                <option value="cancelled">Cancelled</option>
                                <option value="shipped">Shipped</option>
                                <option value="delivered">Delivered</option>
                                <option value="refunded">Refunded</option>
                                <option value="rejected">Rejected</option>
                            </select>
                        </div>
                    </div>

                    <div className="box-full block w-full h-full text-justify  pl-2">
                        <div className="w-full float-left pb-1 pt-0">
                            <select id="delivery-types" className='w-full mt-0 mb-2 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">Delivery Types</option>
                                <option value="delivery">Delivery</option>
                                <option value="dine-in">Dine-in</option>
                                <option value="online">Online</option>
                                <option value="pickup">Pickup</option>
                            </select>
                        </div>
                    </div>

                    <div className="box-full block w-full h-full text-justify pl-2">
                        <div className="w-full float-left pb-1 pt-0">
                            <select id="payment-types" className='w-full mt-0 mb-2 bg-[#F5F5F5] rounded border-0'>
                                <option value="">Payment Status</option>
                                <option value="all">All</option>
                                <option value="Paid">Paid</option>
                                <option value="Unpaid">Unpaid</option>
                                <option value="Refunded">Refunded</option>
                            </select>
                        </div>
                    </div>

                    <div className="box-full block w-full h-full text-justify pl-2">
                        <div className="w-full float-left pb-2 pt-0">
                            <select id="settlement-types" className='w-full mt-0 mb-2 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">Settlement Types</option>
                                <option value="0">Due</option>
                                <option value="1">Processed</option>
                                <option value="2">Settled</option>
                            </select>
                        </div>
                    </div>

                    <div className="box-full flex w-[97%] h-full text-justify py-0.5 px-0.5 -mt-2 ml-2 mb-4 bg-[#F5F5F5] rounded">
                        <div className="w-full h-full float-left">
                            <select id="search-by" className='w-full mt-0 mb-0.5 bg-[#F5F5F5] rounded border-0' defaultValue="search-by-phone" onChange={setSearchParam}>
                                <option value="search-by-phone">Search by Phone</option>
                                <option value="search-by-transaction-id">Search by Transaction Id</option>
                            </select>


                            <input type="text" id="search-by-phone" onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                                autoComplete='off' className="custom-search-fields w-full text-base border-0 rounded placeholder:text-ash" title="01xxxxxxxxx" placeholder='Customer Phone' maxLength={11} />


                            <input type="text" id="search-by-transaction-id" autoComplete='off' className="hidden custom-search-fields w-full text-base border-0 rounded placeholder:text-ash" placeholder='Transaction Id' maxLength={20} />

                        </div>
                    </div>

                    <button onClick={filter} className="custom-btn w-[97%] flow-root float-left ml-2 mt-2">Filter</button>
                    {isFilter && <button onClick={resetFilterData} className="custom-btn ml-2 mt-3 flow-root w-[97%] float-left bg-black text-white border-black" style={{ color: "#FFF" }}>Reset Filter</button>}

                </div>
            </div>
        </div>
    );


};

export default AllOrders;